import { type TextFieldAria } from "@react-aria/textfield";
import { type Context, createContext, type Dispatch, type SetStateAction, use } from "react";

export interface TextFieldRootInterface<T extends "input" | "textarea"> {
  textField?: TextFieldAria<T>;
  setTextField: Dispatch<SetStateAction<TextFieldAria<T> | undefined>>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TextFieldRootContext = createContext<TextFieldRootInterface<any>>({
  setTextField: () => {
    console.warn("Please provide TextFieldRootContext");
  },
});

export const useTextFieldRootContext = <T extends "input" | "textarea">() =>
  use(TextFieldRootContext as Context<TextFieldRootInterface<T>>);
